import './registered.css';
import Parking from './Parking-lot.png';
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';
// import BarChartExample from './BarChart.js';

import { getDatabase, ref, get } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';      // ใช้ Firestore
import { getAuth } from 'firebase/auth';                // ใช้ Authentication
import { getStorage } from 'firebase/storage';          // ใช้ Storage
import { collection, getDocs } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAjjlwqKRBamekFxOryEYvBvj1B5djr-2g",
  authDomain: "clinic-bb643.firebaseapp.com",
  databaseURL: "https://clinic-bb643-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "clinic-bb643",
  storageBucket: "clinic-bb643.firebasestorage.app",
  messagingSenderId: "634326842792",
  appId: "1:634326842792:web:9569cee6f1637d46ca319d",
  measurementId: "G-RJ6Q06NJY1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
// Export modules
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);


function Registered() {
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(null);

  const [value11, setA1] = useState(null);
  const [value12, setA2] = useState(null);
  const [value13, setA3] = useState(null);
  const [value14, setA4] = useState(null);
  const [value21, setB1] = useState(null);
  const [value22, setB2] = useState(null);
  const [value23, setB3] = useState(null);
  const [value24, setB4] = useState(null);
  const [value31, setC1] = useState(null);
  const [value32, setC2] = useState(null);
  const [value33, setC3] = useState(null);
  const [value34, setC4] = useState(null);
  const [value41, setD1] = useState(null);
  const [value42, setD2] = useState(null);
  const [value43, setD3] = useState(null);
  const [value44, setD4] = useState(null);
  const [value45, setD5] = useState(null);
  const [occ, setTotal] = useState(0);
  const lots = 17;
  const [time, settime] = useState(null);

  const [dailyRecords, setDailyRecords] = useState([]);
  useEffect(() => {
    const fetchDailyRecords = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'Total No. of cars'));
        const slotKeys = [
          'A1', 'A2', 'A3', 'A4',
          'B1', 'B2', 'B3', 'B4',
          'C1', 'C2', 'C3', 'C4',
          'D1', 'D2', 'D3', 'D4', 'D5'
        ];

        const formatted = snapshot.docs.map(doc => {
          const data = doc.data();
          const row = { date: doc.id, values: {}, total: 0 };
          let sum = 0;
          slotKeys.forEach(key => {
            const val = data[key] ?? 0;
            row.values[key] = val;
            sum += val;
          });
          row.total = sum;
          return row;
        });

        // เรียงตามวันที่
        formatted.sort((a, b) => a.date.localeCompare(b.date));
        setDailyRecords(formatted);
      } catch (err) {
        console.error('Error fetching Firestore summary:', err);
      }
    };
    fetchDailyRecords();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const keys = ['A1', 'A2', 'A3', 'A4','B1', 'B2', 'B3', 'B4','C1', 'C2', 'C3', 'C4','D1', 'D2', 'D3', 'D4','D5',
        'timestamp'];
      const promises = keys.map(key =>
        get(ref(database, `Y&B_Clinic/${key}`))
      );

      const snapshots = await Promise.all(promises);

      if (snapshots[0].exists()) setA1(snapshots[0].val());
      if (snapshots[1].exists()) setA2(snapshots[1].val());
      if (snapshots[2].exists()) setA3(snapshots[2].val());
      if (snapshots[3].exists()) setA4(snapshots[3].val());
      if (snapshots[4].exists()) setB1(snapshots[4].val());
      if (snapshots[5].exists()) setB2(snapshots[5].val());
      if (snapshots[6].exists()) setB3(snapshots[6].val());
      if (snapshots[7].exists()) setB4(snapshots[7].val());
      if (snapshots[8].exists()) setC1(snapshots[8].val());
      if (snapshots[9].exists()) setC2(snapshots[9].val());
      if (snapshots[10].exists()) setC3(snapshots[10].val());
      if (snapshots[11].exists()) setC4(snapshots[11].val());
      if (snapshots[12].exists()) setD1(snapshots[12].val());
      if (snapshots[13].exists()) setD2(snapshots[13].val());
      if (snapshots[14].exists()) setD3(snapshots[14].val());
      if (snapshots[15].exists()) setD4(snapshots[15].val());
      if (snapshots[16].exists()) setD5(snapshots[16].val());
      if (snapshots[17].exists()) settime(snapshots[17].val());

      let sum = 0;
      for (let i = 0; i < 17; i++) {
        if (snapshots[i].exists()) {
          sum += parseInt(snapshots[i].val(), 10);
        }
      }
      setTotal(sum);
    };

    fetchData(); // เรียกครั้งแรก
    const interval = setInterval(fetchData, 5000); // เรียกทุก 5 วิ
    
    return () => clearInterval(interval);
  }, []);



  // const cellStyle = {
  //   border: '1px solid white',
  //   padding: '0.1vw',
  //   textAlign: 'center',
  //   fontFamily: 'TH Sarabun New, sans-serif',
  //   fontSize: '1.1vw',
  //   fontWeight: 'bold'
  // };
  // const cellStyle2 = {
  //   border: '1px solid white',
  //   padding: '0.1vw',
  //   fontFamily: 'TH Sarabun New, sans-serif',
  //   fontSize: '1vw',
  // };
  //   const cellStyle2_date = {
  //   border: '1px solid white',
  //   padding: '0.1vw',
  //   fontFamily: 'TH Sarabun New, sans-serif',
  //   fontSize: '1vw',
  //   fontWeight: 'bold'
  // };
  // const cellStyle2_0 = {
  //   border: '1px solid white',
  //   padding: '0.1vw',
  //   fontFamily: 'TH Sarabun New, sans-serif',
  //   fontSize: '1vw',
  //   textAlign: 'left'
  // };
  // const cellStyle3 = {
  //   border: '1px solid white',
  //   padding: '0.1vw',
  //   fontFamily: 'TH Sarabun New, sans-serif',
  //   fontSize: '1vw',
  // };
  
  return (
    <div className="App">
      <div className="App-header">
        SMART PARKING LOT
      </div>
      <div className="body">
        {/* {selectedDate && <BarChartExample date={selectedDate} onClose={() => setSelectedDate(false)}/>} */}
        <div className="body_left">
          <div className="body_left_head">
            <table className='table_head'>
              <thead>
                <tr>
                  <th colSpan={19} className="cellStyle" >จำนวนรถที่จอดสะสมต่อวัน</th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th className="cellStyle">วันที่</th>
                  <th className="cellStyle">A1</th>
                  <th className="cellStyle">A2</th>
                  <th className="cellStyle">A3</th>
                  <th className="cellStyle">A4</th>
                  <th className="cellStyle">B1</th>
                  <th className="cellStyle">B2</th>
                  <th className="cellStyle">B3</th>
                  <th className="cellStyle">B4</th>
                  <th className="cellStyle">C1</th>
                  <th className="cellStyle">C2</th>
                  <th className="cellStyle">C3</th>
                  <th className="cellStyle">C4</th>
                  <th className="cellStyle">D1</th>
                  <th className="cellStyle">D2</th>
                  <th className="cellStyle">D3</th>
                  <th className="cellStyle">D4</th>
                  <th className="cellStyle">D5</th>
                  <th className="cellStyle">รวม</th>
                </tr>
              </thead>
              <tbody>
                {dailyRecords.map(({ date, values, total }) => (
                  <tr key={date}>
                    <td className="cellStyle2_date"
                        onClick={() => setSelectedDate(date)}>{date}</td>
                        {/* onClick={() => navigate("/bar-chart", { state: { date } })} */}
                    <td className="cellStyle2">{values.A1 ?? 0}</td>
                    <td className="cellStyle2">{values.A2 ?? 0}</td>
                    <td className="cellStyle2">{values.A3 ?? 0}</td>
                    <td className="cellStyle2">{values.A4 ?? 0}</td>
                    <td className="cellStyle2">{values.B1 ?? 0}</td>
                    <td className="cellStyle2">{values.B2 ?? 0}</td>
                    <td className="cellStyle2">{values.B3 ?? 0}</td>
                    <td className="cellStyle2">{values.B4 ?? 0}</td>
                    <td className="cellStyle2">{values.C1 ?? 0}</td>
                    <td className="cellStyle2">{values.C2 ?? 0}</td>
                    <td className="cellStyle2">{values.C3 ?? 0}</td>
                    <td className="cellStyle2">{values.C4 ?? 0}</td>
                    <td className="cellStyle2">{values.D1 ?? 0}</td>
                    <td className="cellStyle2">{values.D2 ?? 0}</td>
                    <td className="cellStyle2">{values.D3 ?? 0}</td>
                    <td className="cellStyle2">{values.D4 ?? 0}</td>
                    <td className="cellStyle2">{values.D5 ?? 0}</td>
                    <td className="cellStyle2">{total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="body_left_bottom_r">
          <table className="table_stats">
            <tbody>
              <tr>
                <td className="cellStyle2_0">จำนวนที่จอดว่าง</td>
                <td className="cellStyle3">{lots - occ}</td>
              </tr>
              <tr>
                <td className="cellStyle2_0">จำนวนรถที่เข้ามาจอด</td>
                <td className="cellStyle3">{occ}</td>
              </tr>
              <tr>
                <td className="cellStyle2_0">เวลาบันทึก</td>
                <td className="cellStyle3">{time}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button className='back_r' onClick={() => navigate("/")} style={{ cursor: "pointer"}}>
          back
        </button>
        <div className="body_right">
          <div className='A_label'>A</div>
          <div className='B_label'>B</div>
          <div className='C_label'>C</div>
          <div className='D_label'>D</div>
          <img src={Parking} alt="none" style={{ width: '100%' ,height: '100%' ,display: 'block'}} />
          <div className="box_row_1_1" style={{backgroundColor: value11 === 0 ? 'green' : 'red',}}>1</div>
          <div className="box_row_1_2" style={{backgroundColor: value12 === 0 ? 'green' : 'red',}}>2</div>
          <div className="box_row_1_3" style={{backgroundColor: value13 === 0 ? 'green' : 'red',}}>3</div>
          <div className="box_row_1_4" style={{backgroundColor: value14 === 0 ? 'green' : 'red',}}>4</div>
          <div className="box_row_2_1" style={{backgroundColor: value21 === 0 ? 'green' : 'red',}}>1</div>
          <div className="box_row_2_2" style={{backgroundColor: value22 === 0 ? 'green' : 'red',}}>2</div>
          <div className="box_row_2_3" style={{backgroundColor: value23 === 0 ? 'green' : 'red',}}>3</div>
          <div className="box_row_2_4" style={{backgroundColor: value24 === 0 ? 'green' : 'red',}}>4</div>
          <div className="box_row_3_1" style={{backgroundColor: value31 === 0 ? 'green' : 'red',}}>1</div>
          <div className="box_row_3_2" style={{backgroundColor: value32 === 0 ? 'green' : 'red',}}>2</div>
          <div className="box_row_3_3" style={{backgroundColor: value33 === 0 ? 'green' : 'red',}}>3</div>
          <div className="box_row_3_4" style={{backgroundColor: value34 === 0 ? 'green' : 'red',}}>4</div>
          <div className="box_row_4_1" style={{backgroundColor: value41 === 0 ? 'green' : 'red',}}>1</div>
          <div className="box_row_4_2" style={{backgroundColor: value42 === 0 ? 'green' : 'red',}}>2</div>
          <div className="box_row_4_3" style={{backgroundColor: value43 === 0 ? 'green' : 'red',}}>3</div>
          <div className="box_row_4_4" style={{backgroundColor: value44 === 0 ? 'green' : 'red',}}>4</div>
          <div className="box_row_4_5" style={{backgroundColor: value45 === 0 ? 'green' : 'red',}}>5</div>
        </div>
      </div>
      <div className="footer">
        A Smart Vehicle Detection and Counting System for Parking Lots Using Machine Learning Algorithms
        <span style={{ color: '#93B4D9' }}>
          City Research and Deveopment Center, Faculty of Engineering
        </span>
        <span style={{ color: '#93B4D9' }}>
          Chiang Mai University
        </span>
      </div>
    </div>
  );
}

export default Registered;
